export const FIELD_NAMES = {
  DATE: 'date',
  TIME: 'time',
  WATER: 'ounces',
} as const;
